import { Component } from 'react';
import text from 'I18n/utils/unescapedText';
import EditFormControl from 'ContentComponents/cmv2/EditFormControl';
import EditFormLabel from 'ContentComponents/cmv2/EditFormLabel';
import SanitizedLabel from 'ContentComponents/cmv2/SanitizedLabel';
import UIAlert from 'UIComponents/alert/UIAlert';
import { isValueEmpty, hideFieldLabel } from 'ContentComponents/cmv2/utils';
import PersonalizationEditorContext from 'ContentComponents/context/PersonalizationEditorContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.${key}`;
class EditFormField extends Component {
  constructor(props) {
    super(props);
    this.setError = this.setError.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onValidateRequiredValue = this.onValidateRequiredValue.bind(this);
    this.state = {
      error: null,
      missingRequiredValue: false
    };
  }
  componentDidMount() {
    if (this.props.validateOnMount) {
      this.onValidateRequiredValue();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      validateOnMount
    } = this.props;
    if (!prevProps.validateOnMount && validateOnMount) {
      this.onValidateRequiredValue();
    }
  }
  setError(message) {
    this.setState({
      error: message
    });
  }
  onFieldChange(value) {
    const {
      onFieldChange,
      fieldKey,
      field
    } = this.props;
    onFieldChange(fieldKey, value);
    if (this.state.missingRequiredValue && !isValueEmpty(field, value)) {
      this.setState({
        error: null,
        missingRequiredValue: false
      });
    }
  }
  onValidateRequiredValue(value = this.props.value) {
    const {
      field
    } = this.props;
    if (!field.required) {
      return;
    }
    if (isValueEmpty(field, value)) {
      this.setState({
        error: text(i18nKey('requiredMessage')),
        missingRequiredValue: true
      });
    } else if (this.state.missingRequiredValue) {
      this.setState({
        error: null,
        missingRequiredValue: false
      });
    }
  }
  renderDisabledAlert() {
    const {
      disabled,
      field
    } = this.props;
    const {
      disabled_controls
    } = field;
    if (!disabled || !disabled_controls) return null;
    return /*#__PURE__*/_jsx(UIAlert, {
      className: "m-bottom-3",
      type: "tip",
      children: /*#__PURE__*/_jsx(SanitizedLabel, {
        label: disabled_controls.message,
        useStrict: true
      })
    });
  }
  renderDataTokenViewer() {
    const {
      dataTokenValue,
      fieldKey,
      onDataTokenChange,
      useOnDark
    } = this.props;
    return /*#__PURE__*/_jsx(PersonalizationEditorContext.Consumer, {
      children: ({
        TokenViewerComponent
      }) => {
        return /*#__PURE__*/_jsx(TokenViewerComponent, {
          dataTokenValue: dataTokenValue,
          fieldKey: fieldKey,
          onDataTokenChange: onDataTokenChange,
          useOnDark: useOnDark
        });
      }
    });
  }
  renderField(renderedLabel) {
    const {
      componentsByType,
      contentAssistanceEnabled,
      contentTypes,
      currentFieldKey,
      dataTokenValue,
      disabled,
      editor,
      field,
      fieldKey,
      gates,
      highlightedField,
      hostTemplateTypes,
      isEmailOrAnyType,
      isInEmail,
      isPublicContent,
      modulePath,
      onRedirect,
      readOnly,
      resourceProps,
      scopes,
      scrollToField,
      setFieldKey,
      trackFieldAction,
      useOnDark,
      uploadedFileAccess,
      value
    } = this.props;
    const {
      error
    } = this.state;
    const FieldComponent = componentsByType[field.type];
    if (highlightedField.length > 0 && highlightedField[0] === field.name) {
      highlightedField.shift();
    }
    if (dataTokenValue) {
      return this.renderDataTokenViewer();
    }
    if (!FieldComponent) {
      return null;
    }
    return /*#__PURE__*/_jsx(FieldComponent, Object.assign({}, field, resourceProps, {
      componentsByType: componentsByType,
      contentAssistanceEnabled: contentAssistanceEnabled,
      contentTypes: contentTypes,
      currentFieldKey: currentFieldKey,
      editor: editor,
      error: !!error,
      fieldKey: fieldKey,
      gates: gates,
      hostTemplateTypes: hostTemplateTypes,
      isEmailOrAnyType: isEmailOrAnyType,
      isInEmail: isInEmail,
      isPublicContent: isPublicContent,
      label: renderedLabel,
      modulePath: modulePath,
      onFieldChange: this.onFieldChange,
      onRedirect: onRedirect,
      onValidateRequiredValue: this.onValidateRequiredValue,
      readOnly: readOnly || disabled,
      scopes: scopes,
      scrollToField: scrollToField,
      setError: this.setError,
      setFieldKey: setFieldKey,
      highlightedField: highlightedField,
      trackFieldAction: trackFieldAction,
      useOnDark: useOnDark,
      uploadedFileAccess: uploadedFileAccess,
      value: value
    }));
  }
  renderLabel() {
    const {
      field,
      LabelComponent,
      allowFieldReset,
      fieldKey,
      isDefaultValue,
      onFieldReset,
      scrollToField
    } = this.props;
    const {
      label,
      type,
      inherited_value
    } = field;
    if (!label) return null;
    return /*#__PURE__*/_jsx(EditFormLabel, {
      allowFieldReset: allowFieldReset,
      className: "display-inline-flex",
      fieldKey: fieldKey,
      fieldType: type,
      isDefaultValue: isDefaultValue,
      inheritedValue: inherited_value,
      label: label,
      LabelComponent: LabelComponent,
      onFieldUnlink: () => {
        this.onFieldChange(field.default);
      },
      onFieldReset: onFieldReset,
      scrollToField: scrollToField
    });
  }
  render() {
    const {
      allowDataTokens: doesEditorAllowTokens,
      field,
      fieldKey,
      modulePath
    } = this.props;
    const {
      allow_data_tokens: doesFieldAllowTokens,
      label,
      help_text: helpText,
      inline_help_text: inlineHelpText,
      required,
      name
    } = field;
    const {
      error
    } = this.state;
    const hideLabel = hideFieldLabel(field, modulePath === '@hubspot/form');
    const className = 'edit-form-field-wrapper' + (hideLabel || !label ? " edit-form-field---no-label" : "");
    const renderedLabel = this.renderLabel();
    const areDataTokensAllowed = doesEditorAllowTokens && doesFieldAllowTokens;
    return /*#__PURE__*/_jsx(EditFormControl, {
      allowDataTokens: areDataTokensAllowed,
      "aria-label": label || name,
      className: className,
      "data-field-key": fieldKey.join('.'),
      fieldKey: fieldKey.join('.'),
      error: !!error,
      label: !hideLabel ? renderedLabel : null,
      labelClassName: "edit-form-field-wrapper-label",
      onBlur: () => this.onValidateRequiredValue(),
      required: required,
      helpText: !hideLabel ? helpText : null,
      inlineHelpText: !hideLabel ? inlineHelpText : null,
      validationMessage: error,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [this.renderDisabledAlert(), this.renderField(renderedLabel)]
      })
    });
  }
}
EditFormField.defaultProps = {
  fieldSpecificProps: {},
  highlightedField: [],
  readOnly: false,
  validateOnMount: false,
  value: undefined
};
export default EditFormField;